<template>
    <div>
        <div class="bottom-info">
            © 2024 PlayRipple.net  All Rights Reserved.
        </div>
        <div>
            <button type="button" id="top_btn" aria-hidden="true"><span class="sound_only">Move to Top</span></button>
            <aside id="sideBar">
                <h2 class="sound_only">Site All Menu</h2>

                <div id="snbMvAr">
                    <a href="" id="btnHome"><img src="/img/common/logo.png" ></a>
                    <a id="snbClose"><i class="sound_only">Close SideMenu</i></a>
                 </div>
                <!-- SNB // -->
                <div id="snb-out">
                    <ul id="snb">
                        <div class="info-zone" v-if="this.isAuthenticated">
                            <p>Email</p>
                            {{ this.$store.getters.user.email }}
                            <div class="spacer-10"></div>
                            <p>User ID </p>
                            {{ this.$store.getters.user.mem_uuid }}
                        </div>

                        <li class="snb">
                            <h2><a href="" target="_self"><b>Home</b></a></h2>
                        </li>
                        <li class="snb" v-if="this.isAuthenticated">
                            <router-link to="/account" type="button">Account Summary</router-link>
                        </li>
                        <li class="snb">
                            <router-link to="/reset-pw" type="button">Password Reset</router-link>
                        </li>
                        <li class="snb" v-if="!this.isAuthenticated" >
                            <router-link to="/register" type="button">Register</router-link>
                        </li>

                        <li class="snb noInfoPageTit"></li>
                    </ul>

                    <div class="info-zone-left">
                        <div class="m-btn">
                            <router-link v-if="!this.isAuthenticated" to="/login" type="button" >Login</router-link>
                            <router-link v-else to="/logout" @click.native="logout" type="button"  >Logout</router-link>
                        </div>
                    </div>


                </div>
                <!-- // SNB -->

                <!-- //서브메뉴바 하단 정보 -->
            </aside>
            <aside class="clb"></aside>
        </div>
    </div>
</template>


<script>
    $(function() {
        /* 모바일용 메뉴바 */ var articleMgnb = $("#snb li.snb"); articleMgnb.addClass("hide");
        $("#snb li.active").removeClass("hide").addClass("show");
        $("#snb li.active .snb2dul").show();
        $(".snb2dDown").click(function(){ var myArticle = $(this).parents("#snb li.snb");

            if(myArticle.hasClass("hide")){
                articleMgnb.addClass("hide").removeClass("show");
                articleMgnb.find(".snb2dul").slideUp("fast");
                myArticle.removeClass("hide").addClass("show");
                myArticle.find(".snb2dul").slideDown("fast");
            }
            else { myArticle.removeClass("show").addClass("hide");myArticle.find(".snb2dul").slideUp("fast");
            }
        });
    });
    /* select box 포커스 관련 */
    $(document).ready(function() {
        var selectTarget = $('.selectbox select');
        selectTarget.on('focus',function(){
            $(this).parent().addClass('focus');
        });
        selectTarget.on('blur', function(){
            $(this).parent().removeClass('focus');
        });
        selectTarget.change(function(){
            var select_name = $(this).children('option:selected').text();
            $(this).siblings('label').text(select_name);
            $(this).parent().removeClass('focus');
        });
    });
</script>

<script>
import {mapGetters} from "vuex";

export default {
    name: 'app-footer',
    computed: {
        ...mapGetters(["isAuthenticated"]),
        ...mapGetters(["user"]),
    },
    mounted: function (event) {

    },
    methods: {
        redirect() {
            if (!this.isAuthenticated) {
                this.$router.push('/');
            }
        },
        logout() {
            this.$store
                .dispatch("logout", {})
                .then(() => this.redirect())
                .catch(({ message }) => alert(message))
        },
    }
};
</script>
<style>
</style>
